<template>
  <div class="c-news-slider swiper-container-news-slider">
  <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow" />
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in items" :key="index">
        <a :href="route(route_list, 'site.news.detail', {id:item.id})">
          <div class="c-news-slider__img" v-if="isEmpty(item.media_thumbnail_url)">
            <img src="/src/assets/img/common/dummy-thumbnail-landscape.jpg" alt="">
          </div>
          <div class="c-news-slider__img" v-else>
            <img :src="item.media_thumbnail_url" alt="">
          </div>
          <div class="c-news-slider__text">
            <p>{{ item.title }}</p>
          </div>
        </a>
      </div>
    </div>
  <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow" />
  </div>
</template>

<script>
import Swiper from 'swiper/bundle';
import routeMixin from '../../mixins/route.js';
export default {
    props: [
        'items',
        'route_list',
    ],
    mixins: [routeMixin],
    data () {
        return {
            isShow: true,
            isShow2: true,
            swiperOptions: {
                slidesPerView: 1.30,
                slidesPerGroup: 1,
                spaceBetween: 0,
                loop: true, // infinite
                loopAdditionalSlides: 3,
                centeredSlides: true, // centerMode
                speed: 500,
                autoplay: false, // autoplay: false
                pagination: false, // dots: false
                allowTouchMove: true, // swipeToSlide
                breakpoints: {
                  767: {
                      slidesPerView: 1.66,
                      navigation: {
                          nextEl: '.next-arrow',
                          prevEl: '.prev-arrow',
                      },
                  }
                }
            },
        }
    },
    computed: {
        windowWidth() {
            return this.getWindowWidth();
        }
    },
    mounted(){
        this.$nextTick(() => {
            const swiper = new Swiper('.swiper-container-news-slider', this.swiperOptions);
            window.addEventListener('resize', this.getWindowWidth);
        })
    },
    methods:{
        getWindowWidth(event) {
            let breakpoint = document.documentElement.clientWidth;
            if(breakpoint < 767){
                this.isShow = false;
                this.isShow2 = false;
            }
        },
        selectChange(){
            let select = event.target;
            let input = select.closest('div').getElementsByTagName('input')[0];
            //console.log(select.options[0].text, input);
            setTimeout(function(){ input.value = select.options[0].text }, 200);
        },
        resetInputChange(){
            let input = event.target;
            let select = input.nextElementSibling.closest('div').getElementsByTagName('select')[0];
            setTimeout(function(){ input.value = select.options[0].text }, 200);
        },
        isEmpty(value){
            if(value == ''){
                return true;
            }
            return false;
        }
    }
}
</script>

<style scoped>
  .swiper-container-news-slider {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      z-index: 1;

    @media (max-width:767px) {
      overflow: visible;
    }
  }

  /* swiper-slide > a をスライド全体の高さに合わせる */
  .swiper-slide > a {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  @media screen and (min-width: 767px) {
    .c-news-slider .prev-arrow {
      left: -6px;
    }
    .c-news-slider .next-arrow {
      right: -6px;
    }
  }
</style>
